import {
  GetFileUploadUrlCommand,
  GetFileUploadUrlCommandOutput,
  GetFileUploadUrlCommandInput,
} from "@amzn/ttechclaimintakeservice-client";

import { getAuthenticationToken } from "../../auth/helpers";
import { setupClaimIntakeClient } from "../setup/setupClaimIntakeClient";
import { MetricsPublisher } from "../../metrics/metrics";

export async function GetFileUploadUrlService(input: GetFileUploadUrlCommandInput) {
  const token = await getAuthenticationToken();
  if (!token) {
    Promise.reject(new Error("Unauthorized"));
  }
  const client = setupClaimIntakeClient(token);
  const command = new GetFileUploadUrlCommand(input);
  const metricsPublisher = new MetricsPublisher("api.GetFileUploadUrl");

  return await client
    .send(command)
    .then((response: GetFileUploadUrlCommandOutput) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderSuccessMetrics();
      return response;
    })
    .catch((error) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderFatalMetrics();
      throw error;
    });
}
